import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { FadeIn } from "./Reveal";
import { ArrowRight } from "lucide-react";

export default function CtaBand({ title, testid }) {
  const { t } = useLang();
  return (
    <section className="bg-brand py-24" data-testid="cta-band">
      <div className="mx-auto max-w-7xl px-5 text-center sm:px-8">
        <FadeIn>
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-white/70">
            Eco Mobile Solutions
          </p>
          <h2 className="mx-auto mt-6 max-w-4xl font-display text-3xl font-semibold leading-[1.2] text-white sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <div className="mt-10">
            <Link
              to="/contact"
              data-testid={testid}
              className="group inline-flex items-center gap-3 bg-white px-8 py-4 font-display text-[13px] font-bold uppercase tracking-[0.12em] text-brand transition-colors duration-200 hover:bg-brandtint"
            >
              {t.home.cta.button}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
